import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { AddressLookup, AddressLookupFields, AddressLookupSummary } from '../../../../app-shared/models';
import { AddressLookupService } from '../../../../app-shared/services/address-lookup/address-lookup.service';
import { IdDescription } from '../../../models';

@Component({
  selector: 'app-formly-address-lookup',
  templateUrl: './formly-address-lookup.component.html',
  styleUrl: './formly-address-lookup.component.scss',
})
export class FormlyAddressLookupComponent extends FormlyFieldBaseComponent implements OnInit {
  protected options$: Observable<any[]>;

  constructor(private AddressLookupService: AddressLookupService) {
    super();
  }

  ngOnInit(): void {
    this.reset();
  }

  clearSearch(searchBox: HTMLInputElement) {
    this.form.patchValue({ [this.key]: '' } as any);
    searchBox.focus();
    this.options$ = of([]);

    if (this.props.clear) {
      this.props.clear();
    }

    this.clearForm();
  }

  search() {
    const search = this.field.model[this.key];

    this.options$ = this.AddressLookupService.getAddresses(search).pipe(
      takeUntil(this.destroy$),
      map((postcodes: AddressLookupSummary[]) =>
        postcodes.map((postcode: AddressLookupSummary) => ({
          value: postcode.url,
          label: postcode.address,
        })),
      ),
    );
  }

  onSelected(result: any) {
    this.AddressLookupService.getAddressDetails(result.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((address) => {
        if (this.props.selected) {
          this.props.selected(address);
        }
        this.updateForm(address);
      });
  }

  private reset() {
    if (this.key && !this.model[this.key]) {
      this.form.patchValue({ [this.key]: '' } as any);
    }
  }

  updateForm(address: AddressLookup) {
    this.props.countries?.subscribe((countries: IdDescription[]) => {
      const model: AddressLookupFields = {
        line1: address.line_1,
        line2: address.line_2,
        line3: address.line_3,
        line4: address.line_4,
        townCity: address.town_or_city,
        region: address.county,
        postCode: address.postcode,
        countryId: countries.find(
          (x) =>
            x.description.toLowerCase() ===
            address.country
              .replace('England', 'United Kingdom')
              .replace('Scotland', 'United Kingdom')
              .replace('Wales', 'United Kingdom')
              .toLowerCase(),
        )?.id,
      };

      if (!model.line1) {
        model.line1 = address?.locality;
      } else if (!model.line2) {
        model.line2 = address?.locality;
      } else if (!model.line3) {
        model.line3 = address?.locality;
      } else if (!model.line4) {
        model.line4 = address?.locality;
      }

      this.form.patchValue(model as any);
    });
  }

  clearForm() {
    const model: AddressLookupFields = {
      line1: undefined,
      line2: undefined,
      line3: undefined,
      line4: undefined,
      townCity: undefined,
      region: undefined,
      postCode: undefined,
      countryId: undefined,
    };
    this.form.patchValue(model as any);
  }
}
